import { render } from "./ContactPersonEditPage.vue?vue&type=template&id=c195c192"
import script from "./ContactPersonEditPage.vue?vue&type=script&lang=js"
export * from "./ContactPersonEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__